var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#071585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000b64"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d32636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba1827"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "35.40011%",
    y1: "0%",
    y2: "89.131303%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab5423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a3719"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .727273h15.272727v10.909091h-15.272727z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 .72727273h14.2727273v10.90909087h-14.2727273c-.55228475 0-1-.4477152-1-1v-8.90909087c0-.55228475.44771525-1 1-1z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 12-16-5.81818182 16-5.81818182z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2727273 1.40196363-13.14460004 4.77985455 13.14460004 4.77985452z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.6363636 5.84617164c-.0861446-.08614465-.5860262.11325662-.5860262.11325662l-.8685192-.86851917s-.0448314-.48219209.3636363-.72727273c.3088864-.18533179.8876314-.11652498 1.4538192-.36363636.9069068-.39581744 1.8189081-1.09090909 1.8189081-1.09090909l-.5832987 1.60407163s.6681284.34446454.5832986.57774655c-.0245832.06760371-.6767716.27969081-.7272728.36363636-.0959551.15950147.3810664.20785975.2325766.39162614-.4269194.52834191-.9598491 1.06291932-.9598491 1.06291932l-.7272728-.36363636s.1091975-.59008547 0-.69928291z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffc322"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.818182,
    cy: 6.181818,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.09090909 7.27272727h3.63636361c.2008309 0 .3636364-.16280555.3636364-.36363636 0-.20083082-.1628055-.36363636-.3636364-.36363636h-3.63636361c-.20083084 0-.36363636.16280554-.36363636.36363636 0 .20083081.16280552.36363636.36363636.36363636z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.3250615 8.33423455 2.5454546-1.09090908c.1845926-.07911114.2701023-.2928853.1909912-.47747794-.0791112-.18459265-.2928853-.27010232-.4774779-.19099118l-2.5454546 1.09090909c-.18459262.07911114-.27010229.29288529-.19099116.47747791.07911112.18459265.29288526.27010232.47747786.1909912z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs);
export default __webpack_public_path__ + "static/media/AS.90591df8c8e5bfd8e0c8a049e18e6af6.svg";
export { ForwardRef as ReactComponent };